import React, { FC } from 'react';
import Link from '../../../../../../Common/Link/Link';
import { NavItem } from '../../../../../../../interfaces/nav/NavMenu';
import * as classes from './PageListItem.module.scss';
import cn from 'classnames';
import { useTranslation } from 'gatsby-plugin-react-i18next';

interface Props extends NavItem {
  number: number;
}

const PageListItem: FC<Props> = ({ label, description, title, number, url }) => {
  const { t } = useTranslation();

  return (
    <Link path={url} title={title}>
      <div className={classes.wrapper}>
        <div className='row align-items-center'>
          <div className={cn('col-lg-1 col-lg-1 col-md-1 col-12', classes.number)}>0{number + 1}</div>
          <div className={cn('col-lg-3 col-md-3 col-12', classes.label)}>{label}</div>
          <div className={cn('col-lg-5 col-md-6 col-12', classes.description)}>{description && description}</div>
          <div className={'col-lg-3 col-md-2 col-12 d-lg-flex justify-content-lg-end'}>
            <div className={classes.actionWrapper}>
              <div className={classes.linkWrapper}>
                <div className={classes.link}>
                  <span className={classes.text}>{t('preFooter.linkToPageText')}</span>
                  <div className={classes.icon} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PageListItem;
